<template>
  <div class="empty-state">
    <img src="@/assets/arrowUp.svg" :style="computedStyle(arrowConfig)" />
    <img
      v-if="$vuetify.theme.dark"
      src="@/assets/pandaLogoDarkTheme.svg"
      :style="computedStyle(logoConfig)"
    />
    <img
      v-else
      src="@/assets/pandaHappy.svg"
      :style="computedStyle(logoConfig)"
    />
    <div class="empty-state-text" :style="computedStyle(textConfig)">
      <slot
        >{{ textConfig.text }}
        <br />
        <a
          :href="textConfig.href"
          :target="textConfig.target"
          @click="textConfig.onClick"
          >{{ textConfig.hrefText }} &raquo;</a
        ></slot
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    arrowConfig: {
      type: Object,
      default: () => ({
        top: null,
        right: null,
        bottom: null,
        left: null,
        size: 'normal',
        rotation: 0,
      }),
    },
    logoConfig: {
      type: Object,
      default: () => ({
        top: null,
        right: null,
        bottom: null,
        left: null,
        size: 'normal',
        rotation: 0,
      }),
    },
    textConfig: {
      type: Object,
      default: () => ({
        text: '',
        textAlign: 'center',
        textWidth: '100%',
        top: null,
        right: null,
        bottom: null,
        left: null,
        size: 'normal',
        rotation: 0,
        hrefText: '',
        href: '',
        target: '_self',
        onClick: null,
      }),
    },
  },
  methods: {
    computedStyle(config) {
      return {
        top: config.top !== null ? `${config.top}px` : 'auto',
        right: config.right !== null ? `${config.right}px` : 'auto',
        bottom: config.bottom !== null ? `${config.bottom}px` : 'auto',
        left: config.left !== null ? `${config.left}px` : 'auto',
        transform: `rotate(${config.rotation}deg) scale(${config.size})`,

        textAlign: config.textAlign,
        width: config.textWidth,
        position: 'absolute',
      }
    },
  },
}
</script>

<style scoped>
.empty-state {
  position: relative;
}
.empty-state-text {
  max-width: 100%;
  word-wrap: break-word;
  color: #c3c3c3;
}
.text-small {
  font-size: 0.8em;
}
.text-normal {
  font-size: 1em;
}
.text-large {
  font-size: 1.2em;
}
</style>
